import React from "react";
import "./Field.scss";

export const Field = ({ label, children }) => {
  return (
    <div className={"field"}>
      <div className={"field__label"}>{label}</div>
      {children}
    </div>
  );
};
